import { useCallback } from 'react'
import { PerformOperation } from '@/pages/pattern/renderer/main'

/** Thin wrapper over the existing Babylon undo/redo history stack. */
export function useStudioHistory() {
  const undo = useCallback(() => PerformOperation('undoPatternEdit'), [])
  const redo = useCallback(() => PerformOperation('redoPatternEdit'), [])
  return { undo, redo }
}
